/* Harvenly Cart Fix — remove + quantity price update */
(function () {

  /* ─── UTILITY ─────────────────────────────────────── */
  function formatMoney(cents, currency) {
    var amount = (cents / 100).toFixed(2);
    var sym = currency === 'GBP' ? '£' : (currency === 'USD' ? '$' : '€');
    return sym + amount + ' ' + currency;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); });
  }

  function updateCartTotals(cart) {
    /* Subtotal geral */
    var subtotalEls = document.querySelectorAll(
      '[data-cart-subtotal], .cart__subtotal, .totals__subtotal-value, [class*="subtotal"] .price, .cart-subtotal'
    );
    var formatted = formatMoney(cart.total_price, cart.currency);
    subtotalEls.forEach(function(el) { el.textContent = formatted; });

    /* Preco por linha */
    cart.items.forEach(function(item, idx) {
      var lineFormatted = formatMoney(item.line_price, cart.currency);
      /* Seletores comuns de preco de linha no Shrine Pro */
      var lineEls = document.querySelectorAll(
        '[data-cart-line-price="' + (idx + 1) + '"], ' +
        '#CartItem-' + (idx + 1) + ' .price, ' +
        '#CartItem-' + (idx + 1) + ' [class*="price"], ' +
        '.cart-item:nth-child(' + (idx + 1) + ') [class*="price"]'
      );
      lineEls.forEach(function(el) { el.textContent = lineFormatted; });
    });
  }

  /* ─── QUANTITY CHANGE ─────────────────────────────── */
  var quantityTimers = {};

  function handleQuantityChange(input) {
    var line = input.getAttribute('data-line') ||
               input.getAttribute('data-index') ||
               input.closest('[id^="CartItem-"]') && input.closest('[id^="CartItem-"]').id.replace('CartItem-', '');
    if (!line) return;

    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) return;

    /* Debounce 400ms para nao disparar a cada digito */
    clearTimeout(quantityTimers[line]);
    quantityTimers[line] = setTimeout(function() {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartTotals(cart);
        /* Se quantidade foi para 0, recarregar */
        if (qty === 0) {
          if (cart.item_count === 0) { window.location.reload(); return; }
          reloadCartSection();
        }
      })
      .catch(function() {});
    }, 400);
  }

  function reloadCartSection() {
    fetch('/?sections=main-cart-items,cart-drawer')
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var cartHtml = sections['main-cart-items'];
        if (cartHtml) {
          var tmp = document.createElement('div');
          tmp.innerHTML = cartHtml;
          var newC = tmp.querySelector('.js-contents');
          var curC = document.querySelector('.js-contents');
          if (newC && curC) { curC.innerHTML = newC.innerHTML; attachAll(curC); return; }
        }
        window.location.reload();
      })
      .catch(function() { window.location.reload(); });
  }

  /* ─── REMOVE ITEM ─────────────────────────────────── */
  function removeItem(url, btn) {
    var row = btn.closest('tr, .cart-item, [id^="CartItem-"], [class*="cart-item"]');
    if (row) row.style.opacity = '0.4';

    var line = null;
    var match = url.match(/[?&]line=(\d+)/);
    if (match) line = parseInt(match[1], 10);

    var req = line !== null
      ? fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ line: line, quantity: 0 })
        })
      : fetch(url, { method: 'GET', headers: { 'X-Requested-With': 'XMLHttpRequest' } });

    req
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.item_count === 0) { window.location.reload(); return; }
        updateCartTotals(cart);
        fetch('/?sections=main-cart-items,cart-drawer')
          .then(function(r) { return r.json(); })
          .then(function(sections) {
            var updated = false;
            if (sections['main-cart-items']) {
              var tmp = document.createElement('div');
              tmp.innerHTML = sections['main-cart-items'];
              var nC = tmp.querySelector('.js-contents');
              var cC = document.querySelector('.js-contents');
              if (nC && cC) { cC.innerHTML = nC.innerHTML; attachAll(cC); updated = true; }
            }
            if (sections['cart-drawer']) {
              var tmp2 = document.createElement('div');
              tmp2.innerHTML = sections['cart-drawer'];
              var nD = tmp2.querySelector('[id^="CartDrawer-CartItems"], .cart-drawer__cart-items-wrapper');
              var cD = document.querySelector('[id^="CartDrawer-CartItems"], .cart-drawer__cart-items-wrapper');
              if (nD && cD) { cD.innerHTML = nD.innerHTML; attachAll(cD); updated = true; }
              var nT = tmp2.querySelector('[class*="totals"], [id*="totals"]');
              var cT = document.querySelector('[class*="totals"], [id*="totals"]');
              if (nT && cT) cT.innerHTML = nT.innerHTML;
            }
            if (!updated) window.location.reload();
          })
          .catch(function() { window.location.reload(); });
      })
      .catch(function() {
        if (row) row.style.opacity = '1';
        window.location.reload();
      });
  }

  /* ─── ATTACH HANDLERS ─────────────────────────────── */
  function attachAll(root) {
    root = root || document;

    /* Remove buttons */
    var removeSel = 'cart-remove-button a, [id^="Remove-"] a, .cart-remove-button a, a[href*="/cart/change"][href*="quantity=0"]';
    root.querySelectorAll(removeSel).forEach(function(btn) {
      if (btn.dataset.hrFixed) return;
      btn.dataset.hrFixed = '1';
      function onRemove(e) { e.preventDefault(); e.stopPropagation(); removeItem(btn.getAttribute('href'), btn); }
      btn.addEventListener('pointerup', onRemove);
      btn.addEventListener('click', onRemove);
    });

    /* Quantity inputs */
    root.querySelectorAll('input[type="number"][name="updates[]"], input[data-line], .quantity__input, [class*="quantity"] input[type="number"]').forEach(function(inp) {
      if (inp.dataset.hrQty) return;
      inp.dataset.hrQty = '1';
      inp.addEventListener('change', function() { handleQuantityChange(inp); });
    });

    /* Quantity +/- buttons */
    root.querySelectorAll('.quantity__button, [class*="quantity"] button, button[aria-label*="Decrease"], button[aria-label*="Increase"], button[name="minus"], button[name="plus"]').forEach(function(btn) {
      if (btn.dataset.hrQtyBtn) return;
      btn.dataset.hrQtyBtn = '1';
      btn.addEventListener('click', function() {
        /* Aguardar o valor do input atualizar */
        setTimeout(function() {
          var container = btn.closest('[id^="CartItem-"], .cart-item, tr');
          var inp = container && container.querySelector('input[type="number"], input[name*="updates"]');
          if (inp) handleQuantityChange(inp);
        }, 100);
      });
    });
  }

  /* ─── INIT ────────────────────────────────────────── */
  function init() {
    attachAll();
    /* MutationObserver para elementos renderizados dinamicamente (drawer, etc) */
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) attachAll(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function() { attachAll(); });

})();
